export const extraQueryParamsToRecord = <
  Entry extends { key: string; value?: string },
>(
  extraQueryParams: Entry[],
) =>
  extraQueryParams.reduce((acc, { key, value }) => {
    if (key.length > 0) {
      acc[key] = value;
    }

    return acc;
  }, {} as Record<string, Entry['value']>);
